import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("f4e6e06c6a", ".dba930ea7a9438fd__root{display:contents}");
}
export default {"root":"dba930ea7a9438fd__root"};
